import * as React from 'react'
import { Typography } from '@lacedltd/laced-components'
import { useLocale, useTranslation } from 'hooks'
import { iconChevron } from 'images'
import * as S from './PageTemplate.styles'

const PageTemplate: React.FC<React.PropsWithChildren<PageTemplateProps>> = ({
  children,
  heading,
  subHeading,
  breadcrumb = {
    enabled: false
  },
  wide = false
}) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  const myAccount = t('shared.my_account')

  return (
    <S.PageContainer wide={wide}>
      {breadcrumb.enabled && (
        <S.Breadcrumb
          title={breadcrumb.text || myAccount}
          href={localiseUrl(`${breadcrumb.link || '/account'}`)}
        >
          <img src={iconChevron} alt={breadcrumb.text || myAccount} />
          {breadcrumb.text || myAccount}
        </S.Breadcrumb>
      )}
      {heading && (
        <S.PageHeader>
          <S.PageTitle as="h2">{heading}</S.PageTitle>
          {subHeading && (
            <Typography.Text as="p" variant="body">
              {subHeading}
            </Typography.Text>
          )}
        </S.PageHeader>
      )}
      <S.ChildrenContainer>{children}</S.ChildrenContainer>
    </S.PageContainer>
  )
}

export default PageTemplate

interface PageTemplateProps {
  heading?: string
  subHeading?: string
  breadcrumb?: {
    enabled: boolean
    link?: string
    text?: string
  }
  wide?: boolean
}
